<template lang="pug">
v-dialog(v-model="show", :width="modoMarketing ? '560px' : modoTutorial ? '780px' : etapaAtual ? '480px' : '520px'", persistent)
  v-card.onboarding-dialog

    //- ── TELA DE CONVITE PARA O MARKETING ────────────────────────────────
    //- Entra assim que o parceiro responde o feedback: o treinamento acabou e o
    //- próximo passo é ativar promoções e cupons.
    template(v-if="modoMarketing")
      .marketing-hero
        .marketing-hero-topo
          .marketing-badge.Poppins
            span.marketing-badge-dot
            | ABA MARKETING LIBERADA
          v-btn.marketing-close(icon, flat, small, @click="close")
            v-icon(small, color="#6B7280") close

        .marketing-hero-conteudo
          .marketing-hero-textos
            .marketing-title.Poppins Bora atrair clientes agora?
            .marketing-subtitle.Poppins
              | Sua loja está configurada. Faltam #[b.marketing-destaque {{ totalDestaques }} ações] para ela aparecer na frente de quem está com fome #[b neste momento].
          img.marketing-mascote(:src="mascoteIcon", alt="")

      v-card-text.marketing-body
        .marketing-lista-header
          span.marketing-lista-titulo.Poppins O QUE TE ESPERA LÁ
          span.marketing-lista-meta.Poppins {{ totalDestaques }} ações · ~2 min

        .marketing-lista
          .marketing-item(v-for="(item, i) in destaquesMarketing", :key="i")
            .marketing-item-numero.Poppins {{ i + 1 }}
            .marketing-item-textos
              .marketing-item-titulo.Poppins {{ item.titulo }}
              .marketing-item-texto {{ item.texto }}

      v-card-actions.marketing-actions
        v-btn.marketing-btn-primario.white--text(
          depressed, block, color="#1d9a5a"
          @click="irParaMarketing('convite')"
        )
          | Ir para Marketing
          v-icon(right) arrow_forward
        v-btn.marketing-btn-secundario(flat, block, color="#6B7280", @click="voltarDoMarketing") Agora não

    //- ── TELA DE TUTORIAL ────────────────────────────────────────────────
    template(v-else-if="modoTutorial && tutorialEtapa")
      .onboarding-header.mb-2
        v-btn.onboarding-close-btn(icon, flat, small, @click="modoTutorial = false")
          v-icon(small, color="grey") arrow_back
        .onboarding-progress-text
          span.caption {{ tutorialEtapa.titulo }}
        //- Fechar pelo "X" tem o mesmo efeito de "Entendi": o parceiro fica na
        //- tela da etapa com o banner de confirmação disponível.
        v-btn.onboarding-close-btn(icon, flat, small, @click="entendido")
          v-icon(small, color="grey") close

      v-layout.tutorial-layout(row, wrap)
        v-flex.xs12.sm12
          .tutorial-video-wrap
            .tutorial-video-placeholder(v-if="!tutorialInfo.videoUrl")
              v-icon(size="56", color="grey lighten-1") videocam
              p.caption.grey--text.mt-2 Vídeo tutorial em breve
            img.tutorial-video(
              v-else
              :src="tutorialInfo.videoUrl"
              alt="Tutorial"
            )

        v-flex.xs12.sm12.tutorial-texto.Poppins
          .tutorial-pontos-titulo
            v-icon(small, color="primary").mr-1 format_list_bulleted
            span.subtitle-1.font-weight-bold O que verificar:
          ul.tutorial-lista
            li(v-for="(p, i) in tutorialInfo.pontos", :key="i") {{ p }}
        v-flex.xs12.sm12.d-flex.flex-end.Poppins
          v-btn(
            depressed, round, color="primary", dark
            @click="entendido"
          )
            v-icon(left) check_circle_outline
            | Entendi

    //- ── TELA DE ETAPA ATUAL ─────────────────────────────────────────────
    template(v-else-if="etapaAtual")
      .onboarding-header
        .onboarding-progress-text
          span.caption Etapa {{ etapaAtualIndex + 1 }} de {{ totalEtapas }}
        v-btn.onboarding-close-btn(icon, flat, small, @click="close")
          v-icon(small, color="grey") close

      .onboarding-body
        .onboarding-icon-wrapper(:class="etapaAtual.cor")
          v-icon(large, color="white") {{ etapaAtual.icone }}
        .onboarding-step-title {{ etapaAtual.titulo }}
        .onboarding-step-desc {{ etapaAtual.descricao }}

        .onboarding-waiting(v-if="etapaAtual.aguardando")
          v-chip(small, outline, color="orange")
            v-icon(left, small) hourglass_empty
            | Aguardando Sucesso do Cliente

        .onboarding-actions
          v-btn.onboarding-btn-primary(
            v-if="etapaAtual.rota && !etapaAtual.aguardando"
            depressed, block, large, color="primary"
            @click="irParaEtapa"
          )
            | {{ etapaAtual.textoBotao }}
            v-icon(right) arrow_forward
          v-btn.onboarding-btn-whatsapp(
            v-if="etapaAtual.aguardando"
            depressed, block, large, color="success"
            @click="abrirWhatsApp"
          )
            v-icon(left) chat
            | {{ labelFalarCom }}

      .onboarding-dots
        span.dot(
          v-for="(e, i) in etapas"
          :key="i"
          :class="{ 'dot--active': i === etapaAtualIndex, 'dot--done': e.concluida }"
        )

      .onboarding-list-toggle(@click="mostrarLista = !mostrarLista")
        v-icon(small, color="grey darken-1") {{ mostrarLista ? 'expand_less' : 'expand_more' }}
        span.caption.grey--text.text--darken-1  Ver todas as etapas

      v-expand-transition
        .onboarding-step-list(v-show="mostrarLista")
          .onboarding-step-item(v-for="(e, i) in etapas" :key="i" :class="{ 'step-item--active': i === etapaAtualIndex }")
            v-icon.step-status-icon(small, :color="e.concluida ? 'success' : i === etapaAtualIndex ? 'primary' : 'grey'")
              | {{ e.concluida ? 'check_circle' : i === etapaAtualIndex ? 'radio_button_checked' : 'radio_button_unchecked' }}
            span.step-list-title(:class="{ 'grey--text': !e.concluida && i !== etapaAtualIndex }") {{ e.titulo }}

    //- ── TELA DE CONCLUSÃO / FEEDBACK ────────────────────────────────────
    template(v-else)
      .onboarding-header
        span
        v-btn.onboarding-close-btn(icon, flat, small, @click="close")
          v-icon(small, color="grey") close

      v-card-text.conclusao-body
        //- Header: mascote esquerda + textos direita
        .conclusao-topo
          img.conclusao-mascote(:src="mascoteIcon", alt="")
          .conclusao-topo-textos
            .conclusao-trophy-row
              v-icon(:color="feedbackJaRespondido ? 'orange darken-2' : 'primary'", size="28") {{ feedbackJaRespondido ? 'hourglass_empty' : 'emoji_events' }}
            .conclusao-title.Poppins {{ feedbackJaRespondido ? 'Quase lá! Um último passo.' : 'Parabéns, você concluiu o treinamento' }}
            .conclusao-subtitle {{ feedbackJaRespondido ? 'Aguardando a realização dos pedidos de teste.' : 'Estamos quase lá! Responda a pergunta abaixo para finalizar.' }}

        //- Banner de aviso quando já respondido
        .conclusao-aviso-pedidos(v-if="feedbackJaRespondido")
          v-icon(color="orange darken-2", size="20").mr-2 info_outline
          div
            .conclusao-aviso-titulo Pedidos de teste pendentes
            .conclusao-aviso-texto Nossa equipe entrará em contato para realizar os pedidos de teste. Somente após essa etapa sua loja será ativada no app e poderá receber pedidos.

        //- Arte de boas-vindas: liberada assim que o parceiro conclui a parte
        //- dele, com o aviso de só publicar depois da ativação da loja.
        .conclusao-arte(v-if="feedbackJaRespondido")
          img.conclusao-arte-thumb(:src="miniaturaBoasVindas", alt="")
          .conclusao-arte-textos
            .conclusao-arte-titulo.Poppins Sua arte de boas-vindas está pronta
            .conclusao-arte-texto Anuncie a chegada da loja nas redes. Publique depois que a loja for ativada.
          v-btn.conclusao-arte-btn.white--text(depressed, color="#1d9a5a", @click="abrirArteBoasVindas") Ver arte

        template(v-if="!feedbackJaRespondido")
          v-divider.my-3
          .conclusao-form-label.Poppins Como foi sua experiência?
          .conclusao-opcoes
            .conclusao-opcao(
              v-for="op in opcoesFeedback"
              :key="op.valor"
              :class="{ 'opcao--selecionada': feedbackSelecionado === op.valor }"
              @click="feedbackSelecionado = op.valor"
            )
              .opcao-icon-wrap
                v-icon(size="22", :color="feedbackSelecionado === op.valor ? 'primary' : '#9e9e9e'") {{ op.icone }}
              span.opcao-label {{ op.label }}
              v-icon.opcao-check(v-if="feedbackSelecionado === op.valor", size="18", color="primary") check_circle

      v-card-actions.conclusao-actions
        template(v-if="!feedbackJaRespondido")
          v-btn.conclusao-btn-primary(
            depressed, block, color="primary", dark
            :disabled="!feedbackSelecionado"
            :loading="loadingFinalizar"
            @click="finalizar"
          )
            v-icon(left) check_circle_outline
            | Finalizei meu treinamento
        template(v-else)
          .conclusao-acoes-linha
            v-btn.conclusao-btn-primary(
              depressed, color="primary", dark
              @click="solicitarLiberacao"
            )
              v-icon(left) store
              | Solicitar liberação da minha loja
            //- Atalho para a aba Marketing: enquanto aguarda os pedidos de teste,
            //- o parceiro já pode ativar promoções e cupons. O mascote animado é
            //- o chamariz da tela.
            v-btn.conclusao-btn-marketing.white--text(
              depressed, color="#6C2BD9"
              @click="irParaMarketing('conclusao')"
            )
              img.conclusao-btn-mascote(:src="mascoteIcon", alt="")
              | Ir para Marketing
          v-btn.conclusao-btn-secundario(
            flat, block, color="orange darken-2"
            @click="abrirWhatsApp"
          )
            v-icon(left) chat
            | Preciso de ajuda

    //- Abre por cima do onboarding; ao fechar, o parceiro volta à conclusão.
    //- O wrapper zera o placeholder inline-block do v-dialog, que somaria uma
    //- linha vazia ao fim do card (o conteúdo do modal é destacado para a raiz).
    .onboarding-arte-host
      DialogArteDivulgacao(ref="dialogArte")
</template>

<script>
import mascoteIcon from '@/assets/images/onBoardIcon.png';
import { contatoOnboarding, ORIGEM_ONBOARDING, etapasComStatus, mesmaRota } from '@/util/onboarding';
import ArteDivulgacao from '@/util/arteDivulgacao';
import DialogArteDivulgacao from '@/components/dialog/DialogArteDivulgacao';

// Destaques da aba Marketing usados na tela de convite.
const DESTAQUES_MARKETING = [
  {
    titulo: 'Cupons prontos para ativar',
    texto: 'Modelos sugeridos pelo Bigou: dois cliques e você já aparece para quem ainda não conhece a loja.',
  },
  {
    titulo: 'Campanhas com preço em destaque',
    texto: 'Entre nas campanhas do app e mostre preço promocional para quem está navegando agora.',
  },
  {
    titulo: 'Cupom e promoção juntos rendem mais',
    texto: 'Cupom traz o cliente até você e promoção aumenta o ticket médio. Quem usa os dois vê o maior crescimento em pedidos.',
  },
];

const OPCOES_FEEDBACK = [
  { valor: 'sozinho',       icone: 'person_outline',       label: 'Consegui fazer tudo sozinho' },
  { valor: 'maior_parte',   icone: 'check_circle_outline', label: 'Consegui fazer a maior parte' },
  { valor: 'preciso_ajuda', icone: 'help_outline',         label: 'Preciso de ajuda' },
];

export default {
  components: {
    DialogArteDivulgacao,
  },
  watch: {
    // Abre o tutorial automaticamente ao entrar numa tela com etapa pendente.
    '$route.path'() {
      this.$nextTick(() => this.autoAbrirTutorialDaRota());
    },
    // Os dados do onboarding chegam de forma assíncrona: reavalia quando carregam
    // (ex.: abertura direta da página antes do fetchOnboarding concluir).
    onboardingData() {
      this.$nextTick(() => this.autoAbrirTutorialDaRota());
    },
  },
  data() {
    return {
      show: false,
      mostrarLista: false,
      modoTutorial: false,
      modoMarketing: false,
      tutorialEtapa: null,
      feedbackSelecionado: null,
      loadingFinalizar: false,
      mascoteIcon,
      opcoesFeedback: OPCOES_FEEDBACK,
      destaquesMarketing: DESTAQUES_MARKETING,
    };
  },
  computed: {
    onboardingData() {
      return this.$root.onboardingData;
    },
    contatoResponsavel() {
      return contatoOnboarding(this.onboardingData, this.$root.FIREBASE_REMOTE_CONFIG.WPP_SUPORTE);
    },
    labelFalarCom() {
      const contato = this.contatoResponsavel;
      if (contato.origem === 'localidade' && contato.nome) {
        return `Falar com ${contato.nome}`;
      }
      return 'Falar com Sucesso do Cliente';
    },
    etapas() {
      return etapasComStatus(this.onboardingData);
    },
    etapaAtual() {
      return this.etapas.find(e => !e.concluida) || null;
    },
    etapaAtualIndex() {
      if (!this.etapaAtual) return this.etapas.length;
      return this.etapas.indexOf(this.etapaAtual);
    },
    totalEtapas() {
      return this.etapas.length;
    },
    totalDestaques() {
      return this.destaquesMarketing.length;
    },
    feedbackJaRespondido() {
      return !!(this.onboardingData && this.onboardingData.feedback_experiencia);
    },
    miniaturaBoasVindas() {
      return ArteDivulgacao.miniaturaBoasVindas(this.$root.estabelecimentoSelecionado);
    },
    tutorialInfo() {
      return this.tutorialEtapa || { videoUrl: '', pontos: [] };
    },
    // Etapa (ainda pendente) correspondente à rota em que o usuário está agora.
    etapaPendenteDaRotaAtual() {
      const etapa = this.etapas.find(e => e.rota && this.mesmaRota(this.$route.path, e.rota));
      return etapa && !etapa.concluida ? etapa : null;
    },
  },
  methods: {
    open() {
      this.show = true;
      this.mostrarLista = false;
      this.modoTutorial = false;
      this.modoMarketing = false;
      this.tutorialEtapa = null;
      this.feedbackSelecionado = (this.onboardingData && this.onboardingData.feedback_experiencia) || null;
      if (!this.onboardingData) this.$root.fetchOnboarding();
    },
    openTutorial(campo) {
      const etapa = this.etapas.find(e => e.campo === campo);
      if (!etapa) return;
      this.tutorialEtapa = etapa;
      this.modoTutorial = true;
      this.modoMarketing = false;
      this.show = true;
    },
    close() {
      this.show = false;
      this.modoTutorial = false;
      this.modoMarketing = false;
    },
    // "Entendi" e o "X" do tutorial fazem a mesma coisa: fecham o tutorial e
    // deixam o parceiro na tela da etapa. O banner de confirmação não depende
    // mais de qual dos dois foi usado — ele fica visível enquanto a etapa estiver
    // pendente.
    entendido() {
      this.tutorialEtapa = null;
      this.show = false;
      this.modoTutorial = false;
    },
    irParaEtapa() {
      if (!this.etapaAtual || !this.etapaAtual.rota) return;
      const destino = this.etapaAtual.rota;
      this.tutorialEtapa = this.etapaAtual;
      this.show = false;
      // Já está na rota de destino (ignorando barra final): apenas reabre o tutorial.
      if (this.mesmaRota(this.$route.path, destino)) {
        this.exibirTutorial();
        return;
      }
      this.$router.push(destino).catch((err) => {
        // Navegação redundante (ex.: barra final divergente) não é erro: mostra o tutorial.
        if (err && err.name === 'NavigationDuplicated') {
          this.exibirTutorial();
        } else if (err) {
          throw err;
        }
      });
    },
    mesmaRota,
    exibirTutorial() {
      this.$nextTick(() => {
        this.show = true;
        this.modoTutorial = true;
      });
    },
    // Padroniza a abertura: enquanto a etapa da tela atual não for concluída, o
    // tutorial reabre sozinho ao entrar/voltar para a tela — independente de o
    // modal ter sido fechado pelo "X" ou pelo "Entendi".
    autoAbrirTutorialDaRota() {
      if (this.show) return; // não interrompe um modal já aberto
      if (!this.$root.isOnboardingPendente) return;
      const etapa = this.etapaPendenteDaRotaAtual;
      if (!etapa) return;
      // Só abre se a rota for a etapa atual do fluxo (não em etapas adiantadas).
      if (!this.etapaAtual || etapa.campo !== this.etapaAtual.campo) return;
      this.tutorialEtapa = etapa;
      this.modoTutorial = true;
      this.show = true;
    },
    // "Agora não": volta para a conclusão, onde ficam o aviso dos pedidos de
    // teste e o pedido de liberação da loja.
    voltarDoMarketing() {
      this.modoMarketing = false;
    },
    // Fecha o onboarding e leva o parceiro para a tela de Marketing, sinalizando
    // a origem para que ela role direto até as ações.
    irParaMarketing(origem) {
      this.$firebase.logEvent('onboarding_marketing_clicked', {
        establishment_id: this.$root.estabelecimentoSelecionado ? this.$root.estabelecimentoSelecionado.id : null,
        origem: origem || 'convite',
      });
      this.close();
      this.$router.push({ name: 'Marketing', query: { origem: ORIGEM_ONBOARDING } }).catch((err) => {
        // Já estar na mesma rota (com a mesma query) não é erro: o parceiro
        // continua no Marketing, que é o destino.
        if (err && err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    abrirArteBoasVindas() {
      const loja = this.$root.estabelecimentoSelecionado;
      if (!loja) {
        return;
      }
      this.$refs.dialogArte.abrirBoasVindas({
        estabelecimento: loja,
        origem: 'onboarding',
        aviso: ArteDivulgacao.AVISO_LOJA_NAO_ATIVADA,
      });
    },
    abrirWhatsApp() {
      const whatsapp = this.contatoResponsavel.telefone;
      const nome = this.$root.estabelecimentoSelecionado
        ? this.$root.estabelecimentoSelecionado.nome + ' | ' + this.$root.estabelecimentoSelecionado.id
        : '';
      window.open(`https://api.whatsapp.com/send?phone=${whatsapp}&text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20o%20onboarding%20do%20estabelecimento%20${encodeURIComponent(nome)}`, '_blank');
    },
    solicitarLiberacao() {
      const whatsapp = this.contatoResponsavel.telefone;
      const nome = this.$root.estabelecimentoSelecionado
        ? this.$root.estabelecimentoSelecionado.nome + ' | ' + this.$root.estabelecimentoSelecionado.id
        : '';
      window.open(`https://api.whatsapp.com/send?phone=${whatsapp}&text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20a%20libera%C3%A7%C3%A3o%20da%20minha%20loja%20${encodeURIComponent(nome)}`, '_blank');
    },
    async finalizar() {
      if (!this.feedbackSelecionado) return;
      this.loadingFinalizar = true;
      try {
        const estabelecimento_id = this.$root.estabelecimentoSelecionado && this.$root.estabelecimentoSelecionado.id;
        await this.$axios.put('/onboarding', { estabelecimento_id, feedback_experiencia: this.feedbackSelecionado });
        await this.$root.fetchOnboarding();
        // Treinamento concluído: o próximo passo é ativar promoções e cupons.
        this.modoMarketing = true;
        this.$firebase.logEvent('onboarding_marketing_shown', { establishment_id: estabelecimento_id || null });
      } catch (err) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao salvar. Tente novamente.' });
      } finally {
        this.loadingFinalizar = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

// ── TUTORIAL ─────────────────────────────────────────────────────────────────

.tutorial-layout {
  padding: 0 4px 8px;
}

.tutorial-video-wrap {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: #111;
  border-radius: 0;
}

.tutorial-video {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  border: none;
  object-fit: cover;
}

.tutorial-video-placeholder {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.tutorial-texto {
  padding: 16px 20px 12px;
}

.tutorial-titulo {
  font-size: 17px;
  font-weight: 700;
  color: #212121;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 8px;
}

.tutorial-desc {
  font-size: 13px;
  color: #616161;
  line-height: 1.6;
  margin-bottom: 14px;
}

.tutorial-pontos-titulo {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.tutorial-lista {
  padding-left: 20px;
  margin: 0;

  li {
    font-size: 14px;
    color: #424242;
    margin-bottom: 6px;
    line-height: 1.5;
    &::marker { color: #1d9a5a; }
  }
}

// ── ETAPA ATUAL ──────────────────────────────────────────────────────────────

.onboarding-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 0;
}
.onboarding-progress-text span {
  font-size: 12px;
  color: #9e9e9e;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.onboarding-close-btn { margin: 0 !important; }

.onboarding-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 32px 8px;
}
.onboarding-icon-wrapper {
  width: 80px; height: 80px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 20px;
  &.primary        { background: #1976d2; }
  &.deep-purple    { background: #7b1fa2; }
  &.teal           { background: #00796b; }
  &.indigo         { background: #303f9f; }
  &.blue-grey      { background: #546e7a; }
  &.orange         { background: #f57c00; }
  &.orange.darken-1{ background: #fb8c00; }
}
.onboarding-step-title {
  font-size: 22px; font-weight: 700; color: #212121;
  margin-bottom: 8px; font-family: 'Poppins', sans-serif;
}
.onboarding-step-desc {
  font-size: 14px; color: #757575; line-height: 1.6;
  margin-bottom: 8px; max-width: 340px;
}
.onboarding-waiting { margin: 8px 0 12px; }
.onboarding-actions { width: 100%; padding: 16px 0 8px; }
.onboarding-btn-primary, .onboarding-btn-whatsapp {
  border-radius: 8px !important; font-weight: 600;
  text-transform: none !important; font-size: 15px;
}
.onboarding-dots {
  display: flex; justify-content: center; gap: 6px; padding: 12px 0 8px;
}
.dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #e0e0e0; transition: all 0.2s;
  &--active { background: #1d9a5a; width: 20px; border-radius: 4px; }
  &--done   { background: #1d9a5a; }
}
.onboarding-list-toggle {
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; padding: 4px 16px 8px; user-select: none;
  &:hover span { text-decoration: underline; }
}
.onboarding-step-list { padding: 8px 24px 16px; border-top: 1px solid #f5f5f5; }
.onboarding-step-item {
  display: flex; align-items: center; padding: 6px 0;
  &.step-item--active .step-list-title { font-weight: 600; color: #1d9a5a; }
}
.step-status-icon { margin-right: 10px; }
.step-list-title { font-size: 13px; }

// ── TELA DE CONCLUSÃO ─────────────────────────────────────────────────────────

.conclusao-body {
  padding-top: 0 !important;
}

.conclusao-topo {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 4px;
}

.conclusao-mascote {
  width: 100px;
  height: 100px;
  object-fit: contain;
  flex-shrink: 0;
}

.conclusao-topo-textos {
  flex: 1;
  min-width: 0;
}

.conclusao-trophy-row {
  margin-bottom: 4px;
}

.conclusao-title {
  font-size: 24px;
  font-weight: 700;
  color: #212121;
  margin-bottom: 6px;
  line-height: 1.2;
}

.conclusao-subtitle {
  font-size: 12px;
  color: #757575;
  line-height: 1.5;
}

.conclusao-aviso-pedidos {
  display: flex;
  align-items: flex-start;
  background: #FFF8E1;
  border: 1.5px solid #FFB300;
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 16px;
  gap: 4px;
}

.conclusao-aviso-titulo {
  font-size: 13px;
  font-weight: 700;
  color: #E65100;
  margin-bottom: 4px;
  font-family: 'Poppins', sans-serif;
}

.conclusao-aviso-texto {
  font-size: 12px;
  color: #5D4037;
  line-height: 1.5;
}

.conclusao-arte {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #F1FAF4;
  border: 1.5px solid #1d9a5a;
  border-radius: 10px;
  padding: 10px 12px;
  margin-top: 12px;
}

.conclusao-arte-thumb {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.conclusao-arte-textos {
  flex: 1;
  min-width: 0;
}

.conclusao-arte-titulo {
  font-size: 13px;
  font-weight: 700;
  color: #12603A;
  margin-bottom: 2px;
}

.conclusao-arte-texto {
  font-size: 12px;
  color: #4B5563;
  line-height: 1.45;
}

.conclusao-arte-btn {
  flex-shrink: 0;
  margin: 0 !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.onboarding-arte-host {
  height: 0;
  line-height: 0;
}

.conclusao-form-label {
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  margin-bottom: 10px;
  display: block;
}

.conclusao-opcoes {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.conclusao-opcao {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1.5px solid #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: #fff;

  &:hover { border-color: #1d9a5a; background: #f1faf5; }

  &.opcao--selecionada {
    border-color: #1d9a5a;
    background: #f1faf5;
  }
}

.opcao-icon-wrap {
  width: 36px; height: 36px; border-radius: 8px;
  background: #f5f5f5;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  .opcao--selecionada & { background: #e8f5e9; }
}

.opcao-label {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #212121;
}

.opcao-check { flex-shrink: 0; }

.opcao--bloqueada {
  cursor: default !important;
  opacity: 0.8;
  &:not(.opcao--selecionada):hover {
    border-color: #e0e0e0 !important;
    background: #fff !important;
  }
}

// ── TELA DE CONVITE PARA O MARKETING ─────────────────────────────────────────
//
// Verde #1d9a5a = identidade da tela (badge, números, progresso, CTA).
// Laranja #ec721d = acento de ação pendente (contagem, "Próximo passo").

.marketing-hero {
  position: relative;
  padding: 14px 20px 20px;
  background: #fff;
  overflow: hidden;

  // Círculo decorativo verde no canto superior direito.
  &::before {
    content: '';
    position: absolute;
    top: -110px;
    right: -70px;
    width: 240px;
    height: 240px;
    border-radius: 50%;
    background: rgba(29, 154, 90, 0.08);
  }
}

.marketing-hero-topo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.marketing-badge {
  display: inline-flex;
  align-items: center;
  background: #1d9a5a;
  color: #fff;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
}

.marketing-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  margin-right: 7px;
  flex-shrink: 0;
}

.marketing-close {
  position: relative;
  margin: 0 !important;
  background: #F2F4F3;
  border-radius: 50% !important;
}

.marketing-hero-conteudo {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.marketing-hero-textos {
  flex: 1;
  min-width: 0;
}

.marketing-title {
  font-size: 27px;
  font-weight: 700;
  color: #17202A;
  line-height: 1.15;
  margin-bottom: 8px;
}

.marketing-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #6B7280;
  line-height: 1.55;
}

.marketing-destaque {
  color: #ec721d;
  font-weight: 700;
}

.marketing-mascote {
  width: 116px;
  height: 116px;
  object-fit: contain;
  flex-shrink: 0;
}

.marketing-body {
  padding: 4px 20px 0 !important;
}

.marketing-lista-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  padding-top: 14px;
  border-top: 1px solid #EDEFEE;
  margin-bottom: 10px;
}

.marketing-lista-titulo {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.9px;
  color: #9AA0A6;
}

.marketing-lista-meta {
  font-size: 11px;
  font-weight: 600;
  color: #ec721d;
  white-space: nowrap;
}

.marketing-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.marketing-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 13px 14px;
  border: 1px solid #ECECEE;
  border-radius: 12px;
  background: #fff;
}

.marketing-item-numero {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #E8F7EE;
  color: #1d9a5a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.marketing-item-textos {
  flex: 1;
  min-width: 0;
}

.marketing-item-titulo {
  font-size: 14px;
  font-weight: 600;
  color: #17202A;
  margin-bottom: 3px;
}

.marketing-item-texto {
  font-size: 12.5px;
  color: #6B7280;
  line-height: 1.5;
}

.marketing-actions {
  flex-direction: row !important;
  flex-wrap: wrap;
  padding: 14px 20px 18px !important;
  gap: 4px;
  display: flex;
  align-items: stretch;
}

.marketing-btn-primario {
  flex: 1 1 auto;
  margin: 0 !important;
  height: 54px !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 15px !important;
}

.marketing-btn-secundario {
  flex: 1 1 auto;
  margin: 0 !important;
  height: 40px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  font-size: 13px !important;
}

@media (max-width: 599px) {
  .marketing-hero {
    padding: 12px 16px 16px;
  }

  .marketing-title {
    font-size: 22px;
  }

  .marketing-mascote {
    width: 76px;
    height: 76px;
  }

  .marketing-body {
    padding: 4px 16px 0 !important;
  }

  .marketing-actions {
    padding: 12px 16px 16px !important;
  }
}

.conclusao-actions {
  flex-direction: row !important;
  flex-wrap: wrap;
  padding: 8px 16px 16px !important;
  gap: 6px;
  display: flex;
  align-items: stretch;
}

.conclusao-btn-primary {
  flex: 1 1 auto;
  height: 52px !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;

  &.v-btn--disabled {
    background-color: #a5d6a7 !important;
    color: #fff !important;
    opacity: 0.65 !important;
  }
}

// Linha com "Solicitar liberação" + "Ir para Marketing" lado a lado.
.conclusao-acoes-linha {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex: 1 1 100%;
  width: 100%;

  .v-btn {
    flex: 1 1 0;
    min-width: 0 !important;
    margin: 0 !important;
    height: 56px !important;
  }
}

.conclusao-btn-marketing {
  position: relative;
  overflow: hidden;
  height: 52px !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 13.5px !important;
  background-image: linear-gradient(135deg, #7C3AED 0%, #5B21B6 100%) !important;
  box-shadow: 0 4px 14px rgba(108, 43, 217, 0.3) !important;

  // Brilho que cruza o botão de tempos em tempos.
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -60%;
    width: 40%;
    height: 100%;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.32) 50%, rgba(255, 255, 255, 0) 100%);
    transform: skewX(-20deg);
    animation: marketingBrilho 3.4s ease-in-out infinite;
    pointer-events: none;
  }
}

.conclusao-btn-mascote {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-right: 8px;
  flex-shrink: 0;
  animation: mascoteFloat 1.9s ease-in-out infinite;
}

@keyframes mascoteFloat {
  0%, 100% { transform: translateY(0) rotate(-4deg); }
  50% { transform: translateY(-4px) rotate(4deg); }
}

@keyframes marketingBrilho {
  0% { left: -60%; }
  55%, 100% { left: 120%; }
}

.conclusao-btn-secundario {
  flex: 1 1 auto;
  height: 52px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  font-size: 13px !important;
}
</style>

<style lang="scss">
// Fora do escopo do componente de propósito: o `.v-btn__content` é interno do
// Vuetify e vem com `white-space: nowrap` + `flex: 1 0 auto`, então rótulo longo
// estoura o botão em vez de quebrar. O seletor é namespaced pela linha de ações.
.conclusao-acoes-linha .v-btn__content {
  white-space: normal;
  line-height: 1.25;
  flex: 1 1 auto;
  min-width: 0;
}
</style>
